import React from 'react';
import { Link } from 'react-router-dom';

export default function TermsPage() {
  return (
    <div style={{ background: '#ffffff', minHeight: '100vh' }}>
      <div style={{ maxWidth: 760, margin: '0 auto', padding: '48px 24px 64px' }}>

        {/* Back link */}
        <div style={{ marginBottom: 40 }}>
          <Link
            to="/"
            data-testid="terms-back-home"
            style={{
              color: '#1a73e8',
              textDecoration: 'none',
              fontSize: 14,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            &#8592; Back to Home
          </Link>
        </div>

        {/* Header */}
        <h1 style={{ fontSize: 28, fontWeight: 700, color: '#1a1a1a', marginBottom: 4, marginTop: 0 }}>
          Terms &amp; Conditions
        </h1>
        <p style={{ fontSize: 14, color: '#666', marginBottom: 8, marginTop: 0 }}>
          Last Updated: 3rd September 2026
        </p>
        <p style={{ fontSize: 15, color: '#1a1a1a', fontWeight: 600, marginBottom: 4, marginTop: 0 }}>
          Brunei Basketball Association (BBA)
        </p>
        <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '20px 0 28px' }} />

        {/* Intro */}
        <p style={{ fontSize: 15, color: '#333', lineHeight: 1.7, marginBottom: 28, marginTop: 0 }}>
          Welcome to Brunei Basketball Association (&quot;BBA&quot;, &quot;we&quot;, &quot;our&quot;, or &quot;us&quot;). By accessing
          our website, creating an account, or making a court booking through{' '}
          <a href="https://bba.sportsbn.asia" style={{ color: '#1a73e8' }}>bba.sportsbn.asia</a>,
          you agree to be bound by these Terms &amp; Conditions.
        </p>

        {/* Section 1 */}
        <h2 style={h2Style} data-testid="terms-section-1">1. Court Bookings</h2>
        <p style={bodyStyle}>
          All bookings are subject to court availability. A booking is only confirmed with successful payment
          and issuance of a booking confirmation. Customers are responsible for ensuring that booking
          details, including date, time, and court selection, are accurate before payment.
        </p>

        {/* Section 2 */}
        <h2 style={h2Style} data-testid="terms-section-2">2. Payment</h2>
        <p style={bodyStyle}>
          Full payment is required at the time of booking unless otherwise stated. Prices displayed on the
          website are in the applicable local currency. Brunei Basketball Association (BBA) reserves the
          right to revise pricing and promotional offers at any time without prior notice.
        </p>

        {/* Section 3 */}
        <h2 style={h2Style} data-testid="terms-section-3">3. Cancellation &amp; Refund Policy</h2>
        <p style={bodyStyle}>
          All sales are final. We do not offer refunds or cancellations once payment has been processed.
          No-show booked session may be eligible for rescheduling subject to management approval and
          availability of court.
        </p>

        {/* Section 4 */}
        <h2 style={h2Style} data-testid="terms-section-4">4. Late Arrival</h2>
        <p style={bodyStyle}>
          Booked court time cannot be extended due to late arrival. The booking will end at the scheduled
          time regardless of actual arrival time.
        </p>

        {/* Section 5 */}
        <h2 style={h2Style} data-testid="terms-section-5">5. Court Usage &amp; Conduct</h2>
        <p style={bodyStyle}>
          Players must wear appropriate sports attire and non-marking court shoes. Users must use all
          facilities responsibly and follow instructions provided by BBA staff. Any abusive, disruptive,
          unsafe, unlawful, or inappropriate conduct may result in removal from the premises without
          refund. Smoking, illegal substances, weapons, or dangerous activities are strictly prohibited.
        </p>

        {/* Section 6 */}
        <h2 style={h2Style} data-testid="terms-section-6">6. Safety &amp; Personal Responsibility</h2>
        <p style={bodyStyle}>
          Participation in basketball and related activities carries inherent risks of injury. All users
          participate at their own risk and are responsible for ensuring they are medically fit to engage
          in sporting activities. Parents or legal guardians are responsible for minors using the
          facilities.
        </p>

        {/* Section 7 */}
        <h2 style={h2Style} data-testid="terms-section-7">7. Damage to Property</h2>
        <p style={bodyStyle}>
          Customers are responsible for any loss or damage caused to BBA property, facilities, equipment,
          or fixtures due to misuse, negligence, or intentional acts. BBA reserves the right to recover
          repair or replacement costs from the party responsible.
        </p>

        {/* Section 8 */}
        <h2 style={h2Style} data-testid="terms-section-8">8. Limitation of Liability</h2>
        <p style={bodyStyle}>
          To the fullest extent permitted by law, BBA shall not be liable for any injury, loss, damage,
          theft, delay, interruption, or consequential loss arising from the use of our facilities,
          website, or services. Users are responsible for their personal belongings at all times.
        </p>

        {/* Section 9 */}
        <h2 style={h2Style} data-testid="terms-section-9">9. Website &amp; Account Usage</h2>
        <p style={bodyStyle}>
          Users must provide accurate information when creating an account or making a booking. BBA
          reserves the right to suspend or terminate any account involved in fraudulent, abusive, or
          unlawful activity. Unauthorized use of the website or attempts to interfere with its operation
          are prohibited.
        </p>

        {/* Section 10 — updated in revision 4 Sep 2026 */}
        <h2 style={h2Style} data-testid="terms-section-10">10. Privacy Policy and Data Protection</h2>
        <p style={bodyStyle}>
          Personal information collected through our website will be used for booking management,
          customer support, marketing communications (where permitted), and operational purposes in
          accordance with our Privacy Policy. Brunei Basketball Association (BBA) only collect necessary
          information for booking management: Name, email and phone number.
        </p>
        <p style={bodyStyle}>
          We store your personal information for a period that is consistent with our business purposes.
          We will use your data to provide you with the services you requested, such as but not limited
          to email one-time password (OTP) and email notification for booking management.
        </p>
        <p style={bodyStyle}>
          We do not transfer or disclose your information to third parties for purposes other than the
          ones provided. Brunei Basketball Association (BBA) does not store your card or Pocket App
          information. Card &amp; Pocket App payments are accepted securely via the 3rd-party payment
          gateway service provider.
        </p>

        {/* Section 11 */}
        <h2 style={h2Style} data-testid="terms-section-11">11. Force Majeure</h2>
        <p style={bodyStyle}>
          Brunei Basketball Association (BBA) shall not be liable for any failure or delay in providing
          services caused by events beyond our reasonable control, including power failures, natural
          disasters, government actions, public health emergencies, or technical disruptions.
        </p>

        {/* Section 12 */}
        <h2 style={h2Style} data-testid="terms-section-12">12. Amendments</h2>
        <p style={bodyStyle}>
          Brunei Basketball Association (BBA) may update these Terms &amp; Conditions from time to time.
          Updated terms will be posted on our website and take effect immediately upon publication.
        </p>

        {/* Section 13 */}
        <h2 style={h2Style} data-testid="terms-section-13">13. Governing Law</h2>
        <p style={bodyStyle}>
          These Terms &amp; Conditions shall be governed by and construed in accordance with the laws of
          Brunei Darussalam and any disputes shall be subject to the exclusive jurisdiction of the courts
          of that jurisdiction.
        </p>

        <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '36px 0' }} />

        {/* Contact */}
        <h2 style={{ ...h2Style, marginTop: 0 }} data-testid="terms-contact">Contact Us</h2>
        <p style={{ ...bodyStyle, marginBottom: 6 }}>
          <strong>Brunei Basketball Association (BBA)</strong>
        </p>
        <p style={{ ...bodyStyle, marginBottom: 6 }}>
          Website:{' '}
          <a href="https://bba.sportsbn.asia" style={{ color: '#1a73e8' }}>https://bba.sportsbn.asia</a>
        </p>
        <p style={{ ...bodyStyle, marginBottom: 6 }}>
          Email:{' '}
          <a href="mailto:brunei.basketball.association@gmail.com" style={{ color: '#1a73e8' }}>
            brunei.basketball.association@gmail.com
          </a>
        </p>
        <p style={{ ...bodyStyle, marginBottom: 6 }}>Phone: +673 875 3001</p>
        <p style={{ ...bodyStyle, marginBottom: 0 }}>
          Address: Jalan Batu Bersurat (opposite old shophouses by the traffic light),
          Bandar Seri Begawan, Brunei
        </p>

        <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '36px 0 28px' }} />

        {/* Footer */}
        <p style={{ fontSize: 13, color: '#888', marginBottom: 12, marginTop: 0 }}>
          &copy; 2026 Brunei Basketball Association. All rights reserved.
        </p>
        <Link
          to="/"
          style={{
            color: '#1a73e8',
            textDecoration: 'none',
            fontSize: 14,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
          }}
        >
          &#8592; Back to Home
        </Link>

      </div>
    </div>
  );
}

const h2Style = {
  fontSize: 16,
  fontWeight: 700,
  color: '#1a1a1a',
  marginTop: 28,
  marginBottom: 8,
};

const bodyStyle = {
  fontSize: 15,
  color: '#444',
  lineHeight: 1.75,
  marginTop: 0,
  marginBottom: 14,
};
